// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1YDD7","col":"CardReaderDesc_col__22xVk","label":"CardReaderDesc_label__1PGVG"};